import guestlistDuplicationSettingsTemplate
    from '../../../../modules/guestlists/views/modals/guestlist-duplication-settings-modal-controller.tpl.html';
import GuestlistDuplicationSettingsModalController
    from '../../../../modules/guestlists/controllers/modals/guestlist-duplication-settings-modal-controller';
import GuestlistAfterCreateModalController
    from '../../../../modules/guestlists/controllers/modals/after-create-modal-controller';
import afterCreateModalTemplate from '../../../../modules/guestlists/views/modals/after-create-modal.tpl.html';
import guestlistModelReducer from '../../helpers/guestlist-model-reducer';

class DuplicateSingleGuestlistWorkflow {

    constructor($injector) {
        this.injector = $injector;
        this.alert = this.injector.get('Alert');
        this.api = this.injector.get('$http');
        this.modal = this.injector.get('$uibModal');
        this.userStore = this.injector.get('Users');
        this.state = this.injector.get('$state');
        this.navHelper = this.injector.get('NavHelper');

        this.key = 'duplicate-guestlist';
        this.title = 'Copy guestlist';
        this.icon = 'copy';
        this.level = 'highlight';
        this.order = 80;
    }

    async action(payload, store) {
        let duplicateSettings = null;
        try {
            duplicateSettings = await this.modal
                .open({
                    templateUrl: guestlistDuplicationSettingsTemplate,
                    controller: GuestlistDuplicationSettingsModalController,
                    controllerAs: 'vm',
                    resolve: {
                        showGuestlistParams: () => {
                            return true;
                        },
                        oldGuestlist: () => {
                            return store.state.vm.guestlist
                        }
                    }
                })
                .result;
        } catch (e) {
            console.log(e);
        }

        if (!duplicateSettings) {
            return;
        }

        let duplicateResponse = null;
        try {
            duplicateResponse = await this.api
                .post('guestlists/duplicate', {
                    ...duplicateSettings,
                    guestlists: {
                        filters: [
                            {
                                "field": "id",
                                "operator": "=",
                                "value": store.state.vm.guestlist.id
                            }
                        ],
                        count: 1
                    }
                });
        } catch (e) {
            this.alert.error('Error', 'Error while starting duplication. Please try again');
            return;
        }

        this.alert.success('Success', 'Guestlist was duplicated');

        const newGuestlistId = duplicateResponse.data.data.duplicate_information[0].new;

        this.state.go('app.guestlists.rsvps.index', {gid: newGuestlistId});

        this.navHelper.updateEventInformation();
        this.modal.open({
            controller: GuestlistAfterCreateModalController,
            controllerAs: 'vm',
            templateUrl: afterCreateModalTemplate,
            resolve: {
                guestlist: async () => {
                    const guestlistResponse = await this.api.get(`guestlists/${newGuestlistId}`);

                    return new guestlistModelReducer(guestlistResponse.data.data);
                }
            }
        }).result.then(() => {

        }, () => {

        });
    }
}

angular
    .module('festzelt-os.guestlists')
    .factory('duplicateGuestlist', [
        '$injector',
        $injector => new DuplicateSingleGuestlistWorkflow($injector)
    ]);





// WEBPACK FOOTER //
// ./src/app/pages/guestlists/workflows/general/duplicate-guestlist.js